// service-slider.js:
/**
* Service Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Service Slider component.
*/
( function( app ) {
  const COMPONENT = {
    className: 'service-slider',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const button = document.getElementById( 'load-more-services' );
      if ( $( '#load-more-services' ).length ) {
        button.disabled = false;
      }

      const container = document.querySelector( '.ajax-results' );
      const serviceIds = $( '.service-slider' ).attr( 'data-services' ) ?? '';

      loadMoreServices( true );

      $( document ).on( 'click', '#load-more-services', function() {
        loadMoreServices( true );
      } );

      function loadMoreServices( updatePage = false ) {
        let paged = null;

        if ( $( '#load-more-services' ).length ) {
          paged = parseInt( button.dataset.paged ) ?? 1;
          button.disabled = true;
          button.textContent = 'Loading...';
        } else {
          paged = 1;
        }

        const data = {
          'paged': paged,
          'service_ids': serviceIds,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/loadMore',
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            // console.log( data );
            container.insertAdjacentHTML( 'beforeend', data.html );
            if ( updatePage ) {
              paged++;
              button.dataset.paged = paged;
            }

            if ( paged > data.max_paged ) {
              button.style.display = 'none';
            } else {
              button.disabled = false;
              button.textContent = 'Load More';
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
          error: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'service-slider', COMPONENT );
} )( app );
